import { motion } from "framer-motion";
import { Logo } from "./Logo";

const LINKS = [
  { id: "how", label: "How it works", testId: "nav-link-how" },
  { id: "screenshots", label: "Screenshots", testId: "nav-link-screenshots" },
  { id: "privacy", label: "Privacy", testId: "nav-link-privacy" },
  { id: "faq", label: "FAQ", testId: "nav-link-faq" },
];

export function Header({ onNav, onGetApp }) {
  return (
    <motion.header
      data-testid="nav-header"
      initial={{ y: -32, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 border-b border-white/[0.08] bg-ink/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3.5 sm:px-6 lg:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => onNav("top")}
          className="flex items-center gap-2.5"
        >
          <Logo size={28} />
          <span className="font-display text-lg font-extrabold tracking-tight text-acid">
            DMWrapped
          </span>
        </button>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => onNav(l.id)}
              className="text-sm font-medium text-dim transition-colors hover:text-paper"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-cta-button"
          onClick={onGetApp}
          className="rounded-full bg-acid px-5 py-2.5 text-sm font-bold text-ink transition-transform duration-300 hover:scale-[1.04] active:scale-95"
        >
          Get the app
        </button>
      </div>
    </motion.header>
  );
}
